

/**
 * @name BlockVar
 * @param {string} tableName
 * @param {string} code
 */


export const customFuctionMap = {
  /**
   * MONTH 判断月
   * @description
   * 用于检测月份，判断年份是否在[1,12]之间
   * @param {string|number} str 对比的月份
   * @param {string} type 0=>判断月份份是否在[1,当前报告期月份];1=>判断月份是否在[1,12]之间;2=>判断月份是否在[当前报告期月份,12] 
   * @example
   * 当前报告期 6
   * MONTH(1,"1") true
   * MONTH(13,"1") false
   * MONTH(2,"1") true
   * MONTH(9,"1") false
   * MONTH(2,"2") false
   * MONTH(9,"2") ture
   */
  MONTH(str, type = "1") {
    str = (+str)
    let c_m = (+this.$viewData[this.$tableName + '.stat_tab_month'])
    if (_.isNaN(str) || _.isNaN(c_m)) return false
    if (type == 0) {
      return 1 <= str && str <= c_m
    } else if (type == 2) {
      return c_m <= str <= 12
    }
    return 1 <= str && str <= 12
  },
  /**
   * YEAR 判断年
   * @description
   * 用于检测年份 是否在1800年后或者是1800年到报告期
   * @param {string|number} str 对比年份
   * @param {string} type 0=>判断年份是否在1800年到当前报告期所在的年份 [1800,当前报告期];1=>判断年份是否大于等于1800年 [1800,];2=>判断年份是否大于等当前报告期所在的年份 [当前报告期,]
   */
  YEAR(str, type = "1") {
    str = (+str)
    let c_m = (+this.$viewData[this.$tableName + '.stat_tab_year'])
    if (_.isNaN(str) || _.isNaN(c_m)) return false
    if (type == 0) {
      return 1800 <= str && str <= c_m
    } else if (type == 2) {
      return c_m <= str
    }
    return 1800 <= str

  },
  /**
   * CASE 条件过滤
   * @param {*} state
   * @param {*} then
   * @example
   * CASE(1==1,true) => true
   * CASE(1==2,true,false) => false
   * CASE(1==2,true,2) => 2
   * CASE(1==2,true,2==2,3,false) => 3
   */
  CASE() {
    let args = Array.from(arguments)
    let i = 0
    while (i < args.length) {
      let caseFn = args[i]
      let thenFn = args[i + 1]
      if (!thenFn) {
        return caseFn()
      } else {
        if (caseFn()) {
          return thenFn()
        }
      }
      i += 2
    }
  },
  /**
   * IFTHEN 判断执行
   * @param {*} state 
   * @param {*} thenFn 
   * @returns 
   * IFTHEN(1==1,3) // 3
   * IFTHEN(1==2,3) // false
   * IFTHEN(1==1) // true
   */
  IFTHEN(state, thenFn) {
    if (state && thenFn) {
      return thenFn()
    }
    return state
  },
  /**
   * IF 判断
   * IF(logical,value_if_true,value_if_false)：判断一个条件是否满足，如果满足返回一个值，如果不满足则返回另一个值。
   * logical：表示计算结果为TRUE或FALSE的任意值或逻辑表达式。
   * value_if_true：logical为TRUE时返回的值。
   * value_if_false：logical为FALSE时返回的值。
   * @param {*} t 判断对象
   * @param {*} trueVal 正确时返回的值
   * @param {*} falseVal 错误时返回的值
   * @returns {boolean}
   * @example
   * IF(3>2,1,-1) 返回1
   * IF(2+3>6,1,-1) 返回-1
   */
  IF: function (t, trueVal = true, falseVal = false) {
    return t ? trueVal : falseVal
  },
  /**
   * INLIST 存在集合中
   * INLIST(text,text1_list,text2_list,...)：判断文本字符串是否在列表中，在列表中返回TRUE，否则返回FALSE。
   * text：需要进行判断的文本字符串。
   * text1_list,text2_list,...：字符串列表。
   * @param {*} text 需要判断的值
   * @param {*} list 需要匹配的集合
   * @returns {boolean}
   * INLIST("02","02") 返回TRUE
   * INLIST("06","03","06","09") 返回TRUE
   * INLIST("23","16","33") 返回FALSE
   */
  INLIST: function () {
    let [text, ...list] = Array.from(arguments)
    for (let i = 0; i < list.length; i++) {
      if (list[i] == text) {
        return true
      }
    }
    return false
  },
  /**
   * ISCH 中文判断
   * @description 
   * ISCH(test)：判断文本字符串是否全部为汉字，如果是返回TRUE，否则返回FALSE。
   * @param {*} str 需要判断的文本
   * @returns {boolean}
   * @example 
   * ISCH("制度") 返回TRUE
   * ISCH("报表101") 返回FALSE
   */
  ISCH: function (str) {
    return /^[\u4e00-\u9fa5]+$/.test(str)
  },
  /**
   * ISEN 英文判断
   * @description
   * 判断文本字符串是否全部为英文字母，如果是返回TRUE，否则返回FALSE。
   * @param {string} str 需要判断的文本
   * @returns {boolean}
   * @example
   * ISEN("abc") 返回TRUE
   * ISEN("def5") 返回FALSE
   */
  ISEN: function (str) {
    return /^[a-zA-Z]+$/.test(str)
  },
  /**
   * ISLOWER 小写判断
   * @description
   * 字符串是否是小写
   * @param {*} str 需要判断的文本
   * @returns {boolean}
   * @example
   * ISLOWER(“adF”)返回false
   * ISLOWER(“adf”)返回true
   */
  ISLOWER: function (str) {
    return !/[A-Z]/g.test(str)
  },
  /**
   * ISNULL 空值判断
   * @description
   * ISNULL(test)：判断文本字符串是否为空，如果为空返回TRUE，如果不为空则返回FALSE。
   * @param {string} str 需要判断的文本
   * @returns {boolean}
   * @example
   * ISNULL("abc") 返回FALSE
   * ISNULL("") 返回TRUE
   */
  ISNULL: function (str) {
    return str == "" || str == undefined || str == null
  },
  /**
   * ISUPPER 大写判断
   * @description
   * 文本是否全大写
   * @param {*} str 需要判断的文本
   * @returns {boolean}
   * ISLOWER(“adF”)返回false
   * ISLOWER(“ADF”)返回true
   */
  ISUPPER: function (str) {
    return /^[A-Z]+$/.test(str)
  },
  /**
   * LEFT 截取
   * @description
   * LEFT(text,num_chars)：根据指定的字符数返回文本串中的第一个或前几个字符。
   * @param {string} str 需要截取的文本
   * @param {number} num 截取到第几位 必须大于等于0
   * @returns {string}
   * @example
   * LEFT("Hello Everyone",5) 返回“Hello”。
   */
  LEFT: function (str, num) {
    num = (+num);
    if (Number.isNaN(num)) return ""
    return str.substring(0, num)
  },
  /**
   * LEN 长度
   * @description
   * LEN(text)：返回文本串中的字符数。
   * @param {string} str 获取长度的字符串
   * @returns {number}
   * @example
   * LEN("Hello") 返回5
   * LEN(" ") 返回1
   */
  LEN: function (str) {
    return str?.length ?? 0
  },
  /**
   * LOOKAT 匹配位置
   * @description
   * 正则表达式函数:根据正则表达式模式，判断文本字符串是否从开始处匹配
   * @param {*} rg 正则
   * @param {*} str 文本
   * @returns {number}
   * @example
   * LOOKAT('a','da') 返回 1
   * LOOKAT('a','dd') 返回 -1
   * LOOKAT('a','ad') 返回 0
   */
  LOOKAT: function (rg, str) {
    let r = new RegExp(rg).exec(str)
    if (!r) return -1
    return r.index
  },
  /**
   * LOWER 转小写
   * @description
   * 返回将源串转化为小写的新串
   * @param {string} str 文本
   * @returns {string}
   * @example
   * 
   */
  LOWER: function (str) {
    return str?.toLocaleLowerCase() ?? ''
  },
  /**
   * MATCH 匹配
   * @description
   * 正则表达式函数:根据正则表达式模式，判断文本字符串是否完全匹配
   * @param {string} rg 正则
   * @param {string} str 文本
   * @returns {boolean}
   * @example
   * MATCH('abc','hello abc') 返回true
   * MATCH('ccc','hello abc') 返回false
   */
  MATCH: function (rg, str) {
    return new RegExp(rg)?.test(str) ?? false
  },
  /**
   * MAX 最大值
   * @description
   * MAX(number1,number2,…)：返回参数列表中的最大值。
   * @param  {...number} agrs 必须是数字
   * @returns {number|-Infinity}
   * @example
   * MAX(1,2) 返回2
   * MAX(0.1,0,1.2) 返回1.2
   */
  MAX: function () {
    return Math.max(...this.array_develop(Array.from(arguments)))
  },
  /**
   * MID 字符串截取
   * @description
   * MID(text,start_num,num_chars)：返回文本串中从指定位置开始的一定数目的字符，该数目由用户指定。
   * @param {string} str 字符串
   * @param {number} sNum 开始下标 1开始
   * @param {number} len 结束长度
   * @return {string}
   * @example
   * MID("Hello",1,3)返回“Hel”
   * MID("Hello Everyone",7,8)返回“Everyone”
   */
  MID: function (str, sNum, len) {
    sNum = (+sNum)
    len = (+len)
    if (_.isNaN(sNum)) return ''
    sNum -= 1
    if (sNum <= 0) sNum = 1
    if (_.isNaN(len)) {
      len = undefined
    } else {
      len += sNum
    }
    return str?.substring(sNum, len) ?? ''
  },
  /**
   * MIN 最小值
   * @description
   * MIN(number1,number2,…)：返回参数列表中的最小值。
   * @param  {...number} args 
   * @returns {number|Infinity}
   * @example 
   * MIN(5,3,9)等于3
   */
  MIN: function () {
    return Math.min(...this.array_develop(Array.from(arguments)))
  },
  /**
   * NOT 求反
   * @description
   * NOT(logical)：对参数的逻辑值求反，参数为TRUE时返回FALSE，参数为FALSE时返回TRUE
   * @param {*} logic 逻辑计算结果
   * @returns {boolean}
   * @example
   * NOT(2>3) 返回TRUE
   * NOT(2+3>4) 返回FALSE
   */
  NOT: function (logic) {
    return !logic
  },
  /**
   * NOTNULL 非空
   * @description
   * NOTNULL(test)：判断文本字符串是否不为空，如果不为空返回TRUE，如果为空则返回FALSE。
   * @param {string} str 需要进行判断的字符串
   * @returns {boolean}
   * @example
   * NOTNULL("abc") 返回TRUE
   * NOTNULL("") 返回FALSE
   */
  NOTNULL: function (str) {
    return !(str === "")
  },
  /**
   * OR 或者
   * @description
   * OR(logical1,logical2,...)：在其参数组中，任何一个参数逻辑值为TRUE，即返回TRUE；任何一个参数的逻辑值为FALSE，即返回FALSE。
   * @param {...any} args 逻辑
   * @returns {boolean}
   * @example
   * OR(3=3) 返回TRUE
   * OR(1+1=1,2+2=5) 返回FALSE，所有参数的逻辑值为FALSE
   * OR(1+2=3,2+2=5) 返回TRUE，其中一个参数的逻辑值为TRUE
   */
  OR: function () {
    let args = Array.from(arguments)
    for (let i = 0; i < args.length; i++) {
      if (!args[i] == false) return true
    }
    return false
  },
  /**
   * REPLACEALL 全部替换
   * @description
   * 字符串替换函数 返回将源串中的匹配项全部替换为替换项之后的新串
   * @param {string} str 目标文本
   * @param {string} rg 正则
   * @param {string} rStr 替换的内容
   * @param {string} [flags] g 全部
   * @returns {string}
   * @example
   * REPLACEALL("aa12d","\d","w") 返回 aaw2d
   * REPLACEALL("aa12","\d","w","g") 返回 aawwd
   */
  REPLACEALL: function (str, rg, rStr, flags) {
    return str?.replace(new RegExp(rg, flags ?? ''), rStr) ?? ""
  },
  /**
   * RIGHT 右边提取
   * @description
   * RIGHT(text,num_chars)：根据指定的字符数从右开始返回文本串中的最后一个或几个字符。
   * @param {string} str 文本
   * @param {number} start 从几个开始
   * @returns {string}
   * @example
   * RIGHT("Huge sale",4) 返回“sale”
   */
  RIGHT: function (str, start) {
    return str?.substring(start) ?? ""
  },
  /**
   * ROUND 四舍五入取整
   * @description
   * ROUND(number)：返回某个数字经过四舍五入后的取整整数。
   * @param {number} num 数字
   * @returns {number}
   * @example
   * ROUND(8.5)等于9
   * ROUND(1.12)等于1
   */
  ROUND: function (num) {
    return Math.round(num)
  },
  /**
   * SUM 求和
   * @description
   * SUM(number1,number2,…)：求所有参数之和。
   * @param {...number} args 数字
   * @returns {number}
   * @example
   * SUM(70,80) 等于150
   */
  SUM: function () {
    return dsf.math.sum(...this.array_develop(Array.from(arguments)))
  },
  /**
   * TRIM 去空格
   * @description
   * TRIM(text)：清除文本中所有空格，单词间的单个空格除外，也可用于带有不规则空格的文本。
   * @param {string} strArr
   * @returns {string}
   * @example
   * TRIM(" Monthly Report") 返回“Monthly Report”
   * TRIM(" Monthly Report   das ") 返回“Monthly Reportdas”
   */
  TRIM: function (str) {
    return str?.trim()?.replace(/\s{2,}/g, '') ?? ""
  },
  /**
   * TRUNC 向下取整
   * @description
   * TRUNC(number)：将数字的小数部分截去，返回整数。
   * @param {number} num
   * @returns {number|NaN}
   * @example
   * TRUNC(1.3)等于1
   * TRUNC(9.9)等于9
   */
  TRUNC: function (num) {
    return Math.trunc(num)
  },
  /**
   * UPPER 转大写
   * @description
   * 返回将源串转化为大写的新串
   * @param {string} str 
   * @returns {string}
   * @example
   * UPPER("abc") 返回 ABC
   */
  UPPER: function (str) {
    return str.toLocaleUpperCase() ?? ""
  },
  /**
   * VERIFYCODE 组织机构代码编码验证
   * @description
   * 校验组织机构代码
   * 1 长度9位
   * 2 1-2位是大写字母或数字
   * 3 3-8位是数字
   * 4 9位通过前八位计算的值 在{123456789X0}中获取
   * @param {string} value
   * @returns {boolean}
   * @example
   * 
   */
  VERIFYCODE: function (value) {
    if (value == "") {
      return false
    } else if (value.length != 10) {
      return false
    } else {
      // var patrn = /^[0-9A-Z]+$/;
      var reg = /[0-9A-HJ-NPQRTUWXY]{8}-[0-9A-HJ-NPQRTUWXY]/;
      if (reg.test(value) == false) {
        return false
      } else {
        var regLast = /^[0-9X]+$/;

        var lastnum = value.substring(9, 10);

        if (regLast.test(lastnum) == false) {
          // alert("组织统一社会信用代码最后一位只可为数字或大写拉丁字母:X");
          // callback(
          //   new Error("组织统一社会信用代码最后一位只可为数字或大写拉丁字母 X")
          // );
          return false
        } else {
          let value1 = value;
          let value2 = value;
          let newValue = value1.substring(0, 8) + value2.substring(9, 10)
          var ancode;
          var ancodeWeightValue;
          var sum = 0;
          var weightedArray = [3, 7, 9, 10, 5, 8, 4, 2]; //加权因子
          var str = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          for (var i = 0; i < newValue.length - 1; i++) {
            ancode = newValue.substring(i, i + 1);
            ancodeWeightValue = str.indexOf(ancode);
            sum = sum + ancodeWeightValue * weightedArray[i];
          }
          var rightLastnum = 11 - (sum % 11);
          if (rightLastnum == 10) rightLastnum = "X";
          if (rightLastnum == 11) rightLastnum = "0";
          if (lastnum != rightLastnum) {
            return false
          } else {
            return true
          }
        }
      }
    }
  },
  /**
   * VERIFYCREDITCODE 统一社会信用代码校验
   * @description
   * 1.控制统一信用代码的长度必须为18位，且代码只能由数字和大写字母组成
   * 2.按照附件《社会信用代码编码规则》中的规则校验第18位的正确性（只校验第18位）
   * 3.第一条和第二条是“且”的关系
   * 4.该代码不可以为空，要想为空校验通过，则可和其他函数联合使用(比如null函数或notnull函数)
   * @param {string} str
   * @returns {string}
   * @example
   * 
   */
  VERIFYCREDITCODE: function (str) {
    return new Tyshyxdm().verify(str)
  },
  /**
   * INDEX_OF 是否存在位置
   * @description
   * 检查是否存在
   * @param {string} str
   * @param {string} rg
   * @returns {boolean}
   * @example
   * INDEX_OF('文本字符',"文本") 返回true
   * INDEX_OF("文本字符","我呢吧") 返回false
   */
  INDEX_OF: function (str, rg) {
    return str.includes(rg) ?? false
  },
  /**
   * ADD 加
   * @description
   * 加法操作
   * @param {number} v1 
   * @param {number} v2 
   * @returns {number}
   * @example
   * ADD([生产总值]，[毛利润])
   */
  ADD: function (v1, v2) {
    return v1 + v2
  },
  /**
   * SUB 减
   * @description
   * 减法操作
   * @param {number} v1 
   * @param {number} v2 
   * @returns {number}
   * @example
   * SUB([生产总值]，[毛利润])
   */
  SUB: function (v1, v2) {
    return dsf.math.sub(v1, v2)
  },
  /**
   * MUL 乘法
   * @description
   * 乘法操作
   * @param {number} v1 
   * @param {number} v2 
   * @returns {number}
   * @example
   * MUL([生产总值]，[利润率])
   */
  MUL: function (v1, v2) {
    return dsf.math.mul(v1, v2)
  },
  /**
   * MUL 除法
   * @description
   * 乘法操作
   * @param {number} v1 
   * @param {number} v2 
   * @returns {number}
   * @example
   * DIV([利息]，[利率])
   */
  DIV: function (v1, v2) {
    return dsf.math.div(v1, v2)
  },
  /**
   * MOD 求模操作
   * @description
   * 求模操作
   * @param {number} v1 
   * @param {number} v2 
   * @returns {number}
   * @example
   * MOD(10，3)
   */
  MOD: function (v1, v2) {
    return v1 % v2
  },
  /**
   * NOTEQUAL 不等
   * @description
   * 不等
   * @param {*} v1 
   * @param {*} v2 
   * @returns {boolean}
   * @example
   * NOTEQUAL(“a”，“b”) true
   */
  NOTEQUAL: function (v1, v2) {
    return v1 != v2
  },
  /**
   * LESSTHAN 小于
   * @description
   * 小于
   * @param {*} v1 
   * @param {*} v2 
   * @returns {boolean}
   * @example
   * LESSTHAN(21，11)
   */
  LESSTHAN: function (v1, v2) {
    return v1 < v2
  },
  /**
   * LESSTHANEQUALS 小于等于
   * @description
   * 小于等于
   * @param {*} v1 
   * @param {*} v2 
   * @returns {boolean}
   * @example
   * LESSTHANEQUALS(21，11)
   */
  LESSTHANEQUALS: function (v1, v2) {
    return v1 <= v2
  },
  /**
   * GREATERTHAN 大于
   * @description
   * 大于
   * @param {*} v1 
   * @param {*} v2 
   * @returns {boolean}
   * @example
   * GREATERTHAN(21，11)
   */
  GREATERTHAN: function (v1, v2) {
    return v1 > v2
  },
  /**
   * GREATERTHANEQUALS 大于等于
   * @description
   * 大于等于
   * @param {*} v1 
   * @param {*} v2 
   * @returns {boolean}
   * @example
   * GREATERTHANEQUALS(21，11)
   */
  GREATERTHANEQUALS: function (v1, v2) {
    return v1 >= v2
  },
  /**
   * AVG 平均
   * @description
   * 求平均
   * @param  {...number} vals 
   * @returns {number}
   * @example 
   */
  AVG: function () {
    let valDevelops = this.array_develop(Array.from(arguments))
    return dsf.math.sum(...valDevelops) / valDevelops.length
  },
  /**
   * ISNUM 数值判断
   * @description
   * 数值判断是不是数字
   * @param {any} v
   * @returns {boolean}
   * @example
   * ISNUM([生产总值])
   */
  ISNUM: function (v) {
    return dsf.isNumber(v)
  },
  /**
   * VERIFYIDCARD 身份证验证
   * @description
   * 身份证验证
   * @param {*} v 
   * @returns {boolean}
   * @example
   * VERIFYIDCARD([法人身份证号])
   */
  VERIFYIDCARD: function (v) {
    return dsf.idCard(v).type
  },
  /**
   * MAXINDEX 最大索引
   * @description
   * 获取最大值位置
   * @param  {...number} nums 
   * @returns {number}
   * MAXINDEX(2，8，3) 返回1
   */
  MAXINDEX: function () {
    return nums.indexOf(this.MAX(...Array.from(arguments)))
  },
  /**
   * MININDEX 最小索引
   * @description
   * 获取最小值位置
   * @param  {...number} nums 
   * @returns {number}
   * @example
   * MININDEX(8，2，3) 返回1
   */
  MININDEX: function () {
    return nums.indexOf(this.MIN(...Array.from(arguments)))
  },
  /**
   * MAXVALUE 获取最大值
   * @description
   * 获取最大值
   * @param  {...number} nums 
   * @returns {number}
   * @example
   * MAXVALUE(8，2，3) 返回8
   */
  MAXVALUE: function () {
    return this.MAX(...this.array_develop(Array.from(arguments)))
  },
  /**
   * MINVALUE 获取最小值
   * @description
   * 获取最小值
   * @param  {...number} nums 
   * @returns {number}
   * @example
   * MINVALUE(8，2，3) 返回2
   */
  MINVALUE: function () {
    return this.MIN(...Array.from(arguments))
  },
  /**
   * SUBSTR 字符串截取
   * @description
   * 截取字符串开始下标后第几位
   * @param {string} str 
   * @param {number} start 
   * @param {number} len 
   * @returns {string}
   * @example
   * SUBSTR（单元格/行/列,2 ,2) 从第二开始往后截取两位。
   */
  SUBSTR: function (str, start, len) {
    return str?.substring(start, start + len) ?? ""
  },
  /**
   * AGE 年龄
   * @description
   * 计算年龄
   * @param {number} sy 
   * @param {number} sm 
   * @param {number} [ey] 
   * @param {number} [em] 
   * @returns {number}
   * @example
   * 两个参数算到当前日期 AGE(2000，01) = 22 
   * 四个参数计算到目标时间年龄 AGE(2000，01,2020,01) = 20
   */
  AGE: function (sy, sm, ey, em) {
    if (!sy || !sm) return 0
    let stime = new Date(sy, sm - 1)
    let etime = new Date(new Date().getFullYear(), new Date().getMonth());
    if (ey && em) {
      etime = new Date(ey, em - 1)
    }
    return Math.floor((stime - etime) / 1000 / 60 / 60 / 24 / 365)
  },
  /**
   * TOLONG 转长整型
   * @description
   * 转长整型
   * @param {*} str 
   * @returns {number}
   * @example
   * INDEX_TOLONGOF([生产总值])
   */
  TOLONG: function (str) {
    return parseInt(str)
  },
  /**
   * TODOUBLE 转双精度浮点
   * @description
   * 转双精度浮点型
   * @param {*} str 
   * @returns {number}
   * TODOUBLE([生产总值])
   */
  TODOUBLE: function (str) {
    return parseFloat(str)
  },
  /**
   * TOBOOLEAN 转布尔
   * @description
   * 转布尔类型
   * @param {any} v
   * @returns {boolean}
   * @example
   * TODOUBLE([男])
   */
  TOBOOLEAN: function (v) {
    return !!v
  },
  /**
   * TONUMBER 转数值
   * @description
   * 转数值
   * @param {any} v
   * @returns {number}
   * @example
   * TONUMBER("0123")=>123
   */
  TONUMBER: function (v) {
    v = Number(v)
    if (_.isNaN(v)) return 0
    return v
  },
  /**
   * CONCAT 拼接
   * @description
   * 拼接 字符串 或者是 数组
   * @param {...string|...array} agrs 参数类型必须是统一类型
   * @returns {string|array|null}
   * @example
   * CONCAT([1,2],[3])=>[1,2,3]
   * CONCAT("1","2","3")=>"123"
   * CONCAT([1],"2")=>null
   */
  CONCAT: function () {
    let agrs = Array.from(arguments)
    let typeMap = {}
    for (let i = 0; i < agrs.length; i++) {
      typeMap[dsf.type(agrs[i])] = dsf.type(agrs[i])
    }
    if (Object.keys(typeMap).length > 1) {
      return null
    }
    if (typeMap['array']) {
      let r = []
      agrs.forEach((it) => r.concat(it))
      return r
    }
    if (typeMap['string']) {
      let s = ""
      agrs.forEach((it) => s += it)
      return s
    }
    return null
  },
  /**
   * REPEAT 重复校验
   * @description
   * @param {...string|...array} agrs 参数类型必须是统一类型
   * @returns {Boolean}
   * @example
   */
  REPEAT: function () {
    let agrs = Array.from(arguments)
    let typeMap = new Set()
    for (let i = 0; i < agrs.length; i++) {
      if (typeMap.has(agrs[i])) return true
      typeMap.add(agrs[i])
    }
    return false
  },
  /**
   * SQRT 平方根
   * @description
   * 平方根
   * @param {number} num 
   * @returns {number}
   * @example
   * SQRT(16) = 4
   */
  SQRT: function (num) {
    return dsf.math.sqrt(num, 2, 0)
  },
  /**
   * CBRT 立方根
   * @description
   * 立方根
   * @param {number} num 
   * @returns {number}
   * @example
   * CBRT(27) = 3
   */
  CBRT: function (num) {
    return dsf.math.sqrt(num, 3, 0)
  },
  /**
   * GEOMETRICMEAN 几何平均数
   * @description
   * 几何平均数
   * @param  {...number} nums 
   * @returns {number}
   * @example
   * GEOMETRICMEAN(1,2,3)=>2
   */
  GEOMETRICMEAN: function () {
    let nums = Array.from(arguments)
    return this.SUM(nums) / nums.length
  },
  /**
   * POWER 幂函数
   * @description
   * 幂函数
   * @param {number} num 
   * @param {number} num2 次数
   * @example
   * POWER(16,2) => 256
   * POWER(16,1/2) => 4 
   * POWER(8,1/3) => 2
   */
  POWER: function (num, num2) {
    return Math.pow(num, num2)
  },
  /**
   * EQUALS 等于
   * EQUALS(s1,s2)：比较两个字符串的内容是否相同或者两个数字是否相等。
   * @param {string|number} a1 需要比较的文本、数字串。
   * @param {string|number} a2 需要比较的文本、数字串。
   * @returns {boolean}
   * EQUALS("duck","duck")=>true
   * EQUALS("Hello","Hell")=>false
   * EQUALS(18,18)=>true
   * EQUALS(10,1)=>false
   */
  EQUALS: function (a1, a2) {
    return a1 === a2
  },
  /**
   * AND 并且
   * AND(logical1,logical2,...)：所有参数的逻辑值为真时，返回TRUE；只要一个参数的逻辑值为假，即返回FALSE。
   * Logical1,logical2,...：为需要进行检验的一个或者多个条件，分别为TRUE或者FALSE。
   * @param {...*} 
   * @returns 
   * @example
   *  BGQ(A,-1)返回的是格子A的上期数据
   */
  AND: function () {
    var args = Array.prototype.slice.call(arguments);
    for (let i = 0; i < args.length; i++) {
      if (!args[i]) return false
    }
    return true
  },
  /**
   * CEIL 向上取整
   * CEIL(number)：将数字的小数部分截去，向上取整。
   * 
   * @param {*} num 
   * @returns {number|string} 不是数字则返回空字符串
   * @example
   * CEIL(1.3)等于2
   * CEIL(9.9)等于10
   */
  CEIL: function (num) {
    num = MathMath.ceil(num)
    if (Number.isNaN(num)) return ''
    return num
  },
  /**
   * VERIFYCH 中文验证
   * 描述：能检测的功能有：
    (1)用于检查字符串中的中文个数
     (2)是否出现特定的字符
     (3)是否必须全为汉字
   * VERIFYCH(单元格/行/列,最少汉字个数,关键词,是否全为中文)。
   *
   * @param {String} target 要验证的文本
   * @param {Number} minNumber 中汉字最少必须有多少个
   * @param {String} mateText 指明要判断出现的特定字符
   * @param {Number} state 是否必须全是汉字 "1" 表示全为汉字 "0" 表示不全为汉字
   * @example 
   * 例如：VERIFYCH([3|2],"2","北京","1")
   * VERIFYCH([3|2],"0","","0")
   * VERIFYCH([3|2],"2","公司","0")
   */
  VERIFYCH: function (target, minNumber, mateText, state) {
    if (!target) {
      return false
    }
    let isMinNumber = true
    let isAllChinese = true
    let isMateText = true
    if (minNumber > 0) {
      let isNum = 0
      for (let i = 0; i < target.length; i++) {
        if (/^[\u4e00-\u9fa5]$/.test(target.charAt(i))) {
          isNum++
        }
      }
      isMinNumber = isNum >= minNumber
    }
    if (mateText) {
      isMateText = target.includes(mateText)
    }
    if (state == 1) {
      isAllChinese = /^[\u4e00-\u9fa5]+$/.test(target)
    }
    return isMinNumber && isAllChinese && isMateText
  },
  /**
   * ABS 绝对值
   * ABS(number)：返回参数的绝对值。
   * @param {*} num 
   * @returns {number|string} 不是数字则返回空字符串
   * ABS(1-3)=>2
   * ABS(3-1)=>2
   */
  ABS: function (num) {
    num = Math.abs(num)
    if (Number.isNaN(num)) return ''
    return num
  },
  /**
   * CURRENTTIME 获取当前时间
   * 获取当前系统时间函数：
   * 年的表示形式yyyy
   * 月的表示形式MM
   * 日的表示形式dd
   * 时的表示形式HH
   * 分的表示形式mm
   * 秒的表示形式ss
   * 如：yyyy-MM-dd HH:mm:ss
   * 如：yyyy/MM/dd HH:mm:ss
   * 如：yyyy年MM月dd日HH时mm分ss秒
   * @param {string} format 
   * @returns {string}
   * CURRENTTIME('yyyy') 2022
   * CURRENTTIME('yyyy-MM') 2020-01
   * CURRENTTIME('yyyy-MM-dd) 2020-01-01
   * CURRENTTIME('yyyy-MM-dd HH:mm:ss')  2020-01-01 20:30:00
   */
  CURRENTTIME: function (format) {
    format = format.replace(/mm/g, 'ii').replace(/MM/g, 'mm').replace(/HH/g, 'hh')
    return dsf.date.format(new Date(), format)
  },
  /**
   * FIND 查找
   * 正则表达式函数:根据正则表达式模式，判断文本字符串是否从指定位置之后存在匹配
   * @param {string} 正则
   * @param {string} 匹配文本
   * @param {number} 是否从该下标开始
   * @returns {boolean}
   * FIND("abs","hell abs",2)=>true
   * FIND("abs","hell abs",6)=>false
   */
  FIND: function (express, text, start) {
    start = (+start)
    if (!express || !text || Number.isNaN(start)) return false
    const re = new RegExp(express)
    let r = re.exec(text)
    if (!r) return false
    if (r.index >= start) {
      return true
    }
    return false
  }
}

export const privateFuctionMap = {
  get_main: function (tableName, code) {
    return this?.$viewData?.[`${tableName}.${code}`]
  },
  get_row: function (tableName, code) {
    return this?.$row?.[`${tableName}.${code}`]
  },
  get_sub_table: function (tableName) {
    return this?.$viewData?.[tableName] || []
  },
  get_sub_table_field: function ({ tableName, code, type, expand }) {
    let fieldKey = [`${tableName}.${code}`]
    let value = this.get_sub_table(tableName).map((it) => {
      let val = it[fieldKey]
      if (expand) val = it[fieldKey][expand]
      if (type == 'number') {
        return this.TONUMBER(val)
      }
      return val
    })

    return {
      value,
      tableName,
      code
    }
  },
  get_sub_table_catalog_code_row({ tableName, code }, codeList) {
    let codeKey = `${tableName}.stats_meta_code`
    let value = this.get_sub_table(tableName)
    return value
      .filter((ite) => ite[codeKey] && codeList.includes(ite[codeKey]))
  },
  array_develop(args) {
    let arr = []
    let cloneArgs = dsf.isArray(args) ? [...args] : []
    while (cloneArgs?.length) {
      let it = cloneArgs.shift()
      if (Array.isArray(it)) {
        cloneArgs.unshift(...it)
      } else {
        arr.push(it)
      }
    }
    return arr
  }
}

//统一社会信用代码
function Tyshyxdm() {
  this.firstarray = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  this.firstkeys = [3, 7, 9, 10, 5, 8, 4, 2];
  this.secondarray = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'T', 'U', 'W', 'X', 'Y'];
  this.secondkeys = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];
  this.verify = function (str) {
    var code = str.toUpperCase();
    if (code.length != 18) {
      return false;
    }
    var reg = /^\w\w\d{6}\w{9}\w$/;
    if (!reg.test(code)) {
      return false;
    }
    reg = /^[1,5,9,Y]\w\d{6}\w{9}\w$/;
    if (!reg.test(code)) {
      return false;
    }
    reg = /^(11|12|13|19|51|52|53|59|91|92|93|Y1)\d{6}\w{9}\w$/;
    if (!reg.test(code)) {
      return false;
    }
    reg = /^(11|12|13|19|51|52|53|59|91|92|93|Y1)\d{6}\w{9}\w$/;
    if (!reg.test(code)) {
      return false;
    }
    var firstkey = this.calc(code.substr(8), this.firstarray, this.firstkeys, 11);
    var firstword;
    if (firstkey < 10) {
      firstword = firstkey;
    }
    if (firstkey == 10) {
      firstword = 'X';
    } else if (firstkey == 11) {
      firstword = '0';
    }
    if (firstword != code.substr(16, 1)) {
      return false;
    }
    var secondkey = this.calc(code, this.secondarray, this.secondkeys, 31);
    var secondword = this.secondarray[secondkey];
    if (!secondword || secondword != code.substr(17, 1)) {
      return false;
    }
    var word = code.substr(0, 16) + firstword + secondword;
    if (code != word) {
      return false;
    }
    return true;
  }
  this.calc = function (code, array1, array2, b) {
    var count = 0;
    for (var i = 0; i < array2.length; i++) {
      var a = code[i];
      count += array2[i] * array1.indexOf(a);
    }
    return b - count % b;
  }
}

export const customFuctionList = [
  ["IF", "判断"],
  ["INLIST", "存在集合中"],
  ["ISCH", "中文判断"],
  ["ISEN", "英文判断"],
  ["ISLOWER", "小写判断"],
  ["ISNULL", "空值判断"],
  ["ISUPPER", "大写判断"],
  ["LEFT", "截取"],
  ["LEN", "长度"],
  ["LOOKAT", "匹配位置"],
  ["LOWER", "转小写"],
  ["MATCH", "匹配"],
  ["MAX", "最大值"],
  ["MID", "字符串截取"],
  ["MIN", "最小值"],
  ["NOT", "求反"],
  ["NOTNULL", "非空"],
  ["OR", "或者"],
  ["REPLACEALL", "全部替换"],
  ["RIGHT", "右边提取"],
  ["ROUND", "四舍五入取整"],
  ["SUM", "求和"],
  ["TRIM", "去空格"],
  ["TRUNC", "向下取整"],
  ["UPPER", "转大写"],
  ["VERIFYCODE", "组织机构代码编码验证"],
  ["VERIFYCREDITCODE", "统一社会信用代码校验"],
  ["INDEX_OF", "是否存在位置"],
  ["ADD", "加法"],
  ["SUB", "减法"],
  ["MUL", "乘法"],
  ["DIV", "除法"],
  ["MOD", "求模操作"],
  ["NOTEQUAL", "不等"],
  ["LESSTHAN", "小于"],
  ["LESSTHANEQUALS", "小于等于"],
  ["GREATERTHAN", "大于"],
  ["GREATERTHANEQUALS", "大于等于"],
  ["AVG", "平均"],
  ["ISNUM", "数值判断"],
  ["VERIFYIDCARD", "身份证验证"],
  ["MAXINDEX", "最大索引"],
  ["MININDEX", "最小索引"],
  ["MAXVALUE", "获取最大值"],
  ["MINVALUE", "获取最小值"],
  ["SUBSTR", "字符串截取"],
  ["AGE", "年龄"],
  ["TOLONG", "转长整型"],
  ["TODOUBLE", "转双精度浮点"],
  ["TOBOOLEAN", "转布尔"],
  ["TONUMBER", "转数值"],
  ["CONCAT", "拼接"],
  ["SQRT", "平方根"],
  ["CBRT", "立方根"],
  ["GEOMETRICMEAN", "几何平均数"],
  ["POWER", "幂函数"],
  ["EQUALS", "等于"],
  ["AND", "并且"],
  ["CEIL", "向上取整"],
  ["ABS", "绝对值"],
  ["CURRENTTIME", "获取当前时间"],
  ["FIND", "查找"],
  ["CURRENTROWCATALOGCOD", "获取带目录子表当前行code"],
  ["IFTHEN", "判断执行"],
  ["SUMIFAND", "满足条件执行求和"],
  ["CASE", "条件过滤"],
  ["VERIFYCH", "中文验证"],
  ["REPEAT", "重复校验"],
]